"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoize = void 0;
function memoize(fn, ttl) {
    const cache = { promise: undefined, lastSet: 0 };
    return async () => {
        if (cache.promise === undefined || Date.now() - cache.lastSet > ttl) {
            cache.lastSet = Date.now();
            cache.promise = fn();
        }
        return await cache.promise;
    };
}
exports.memoize = memoize;
//# sourceMappingURL=memoize.js.map